/* eslint-disable */
/**
 * Resolves `{{token}}` or direct `#token#` placeholders against a values map — generic across
 * whatever domain is calling it (nudge emails, payslips, rating windows, ...).
 * The caller decides what tokens exist and how to compute their values; this
 * module only does the substitution.
 */

import { escapeHtml } from "./textToHtml";

/** Plain-text substitution — use for subjects and other non-HTML strings. */
export function resolvePlaceholders(
  text: string,
  values: Record<string, string>
): string {
  return text.replace(/\{\{(\w+)\}\}|#[^#]+#/g, (match, key?: string) =>
    (key || match) in values ? values[key || match]! : match
  );
}

/**
 * HTML substitution — same as resolvePlaceholders, but escapes each value first
 * so a value can never inject markup into an already-sanitized body. Use this
 * for placeholders inside HTML (e.g. an email body), never resolvePlaceholders.
 */
export function resolvePlaceholdersInHtml(
  html: string,
  values: Record<string, string>
): string {
  return html.replace(/\{\{(\w+)\}\}|#[^#]+#/g, (match, key?: string) =>
    (key || match) in values ? escapeHtml(values[key || match]!) : match
  );
}
